import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import { FAQ } from "../config/content";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-[#0B110D]" data-testid="faq-section">
      <div className="max-w-[820px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{FAQ.eyebrow}</Eyebrow>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-none tracking-wide" data-testid="faq-heading">
            EVERYTHING YOU WANT TO <span className="text-[#22C55E]">ASK</span>
          </h2>
        </Reveal>
        <div className="mt-10 space-y-3" data-testid="faq-list">
          {FAQ.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div className={`rounded-xl border transition-colors ${isOpen ? "bg-[#0F1712] border-[#22C55E]/40" : "bg-[#0F1712]/60 border-[#22C55E]/[0.15]"}`} data-testid={`faq-item-${i}`}>
                  <button
                    className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`faq-question-${i}`}
                  >
                    <span className="font-semibold text-white text-sm sm:text-base">{item.q}</span>
                    <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.25 }}>
                      <ChevronDown className={`w-5 h-5 ${isOpen ? "text-[#22C55E]" : "text-[#6B7A70]"}`} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-5 sm:px-6 pb-5 text-sm sm:text-base text-[#A7B3AA] leading-relaxed" data-testid={`faq-answer-${i}`}>{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
